'use strict';

exports.__esModule = true;
exports.MEDIA_PLAYER_DEFAULTS = exports.BG_VIDEO_DEFAULTS = undefined;
exports.fixMediaTitleLength = fixMediaTitleLength;
exports.getVideoBackgroundObject = getVideoBackgroundObject;
exports.getMediaPlayerVideoObject = getMediaPlayerVideoObject;
exports.getVideoPosterObject = getVideoPosterObject;
exports.getImageBackgroundObject = getImageBackgroundObject;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHARS_TO_ADD = '...';
var NUM_OF_CHARS_TO_KEEP = 3;
var BG_VIDEO_DEFAULTS = exports.BG_VIDEO_DEFAULTS = {
  opacity: 1,
  autoplay: true,
  loop: true,
  preload: 'auto',
  mute: true
};
var MEDIA_PLAYER_DEFAULTS = exports.MEDIA_PLAYER_DEFAULTS = {
  opacity: 1,
  preload: 'auto'
};
var TITLE_LENGTH_LIMIT = 100;

function url2uri(url) {
  return url.replace(/^(.*[\/])/, '');
}

function getIdFromUrl(fileUrl) {
  var result = fileUrl.match(/(?:\/|^)([0-9a-fA-F_]+)(?:\/|$)/);
  return result.length > 1 ? result[1] : '';
}

function fixMediaTitleLength(value, lengthLimit) {
  if (value.length <= lengthLimit) {
    return value;
  }
  var arr = value.split('');
  var numOfCharsToRemove = value.length - lengthLimit + CHARS_TO_ADD.length;
  var isFileTypeSuffix = value.lastIndexOf('.') > value.length - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  var fileTypeSuffixIndex = isFileTypeSuffix ? value.lastIndexOf('.') : value.length - 1;
  var removeIndex = fileTypeSuffixIndex - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  arr.splice(removeIndex, numOfCharsToRemove, CHARS_TO_ADD);
  return arr.join('');
}

/**
 * extracts the generated images from the video payload
 * @param fileOutput
 * @returns {[]} images uri
 */
function parseVideoPosters(fileOutput) {
  return _lodash2.default.map(fileOutput.image, function (image) {
    return url2uri(image.url);
  });
}

/**
 * extracts the video qualities from the video payload
 * @param fileOutput
 * @returns {[{width: number, height: number, quality: string, url: string} || {}]} qualities array
 */
function parseVideoQualities(fileOutput) {
  var mp4Videos = _lodash2.default.filter(fileOutput.video, { format: 'mp4' });
  var storyboard = _lodash2.default.find(fileOutput.storyboard, { format: 'mp4' });
  var qualities = _lodash2.default.map(mp4Videos, function (quality) {
    return _lodash2.default.pick(quality, ['width', 'height', 'quality', 'url']);
  });

  if (storyboard) {
    qualities.push({
      quality: 'storyboard',
      width: storyboard.width,
      height: storyboard.height,
      url: storyboard.url
    });
  }

  return qualities;
}

/**
 * extracts the video adaptive formats and url from the video payload
 * @param fileOutput
 * @returns {[{format: string, url: string}] || []} qualities array
 */
function parseAdaptiveUrls(fileOutput) {
  var adaptiveVideo = getObjectValueByKey(fileOutput, 'adaptive_video');
  return _lodash2.default.map(adaptiveVideo, function (item) {
    return {
      format: item.format,
      url: item.url
    };
  });
}

function parseMediaFeatures(fileInfo) {
  var mediaFeatures = [];
  if (fileInfo.tags && _lodash2.default.includes(fileInfo.tags, '_mp4_alpha')) {
    mediaFeatures.push('alpha');
  }
  return _lodash2.default.isEmpty(mediaFeatures) ? null : mediaFeatures;
}

/**
 * since media manager return different cases .
 * @param object
 * @param key
 * @returns {*}
 */
function getObjectValueByKey(object, key) {
  return object[key] || object[_lodash2.default.camelCase(key)];
}

/**
 * parse media manager video file response into WixVideo object scheme
 * @param fileInfo - media manager, video file object response (https://docs.google.com/a/wix.com/document/d/1_fqnV0JcTfMHVpqKJIR9jFV-l6YGxv8_7cc3XQ7I2OY)
 * @param info - media manager, folder information
 * @returns {{type: string, title: *, videoId: string, duration: number, posterImageRef: *, generatedPosters: string[], qualities: ({width: number, height: number, quality: string, url: string}|{})[], artist: {name: (*|string), id: (*|string)}, hasAudio: boolean, fps: (string|*)}}
 * https://docs.google.com/a/wix.com/document/d/1BcbazImlny7Y5k4dE5B6n-FD4_NkXAeluefsl8324Js
 */
function parseVideoFileInfo(fileInfo, info) {
  var fileInput = getObjectValueByKey(fileInfo, 'file_input');
  var fileOutput = getObjectValueByKey(fileInfo, 'file_output');
  var videoId = getIdFromUrl(fileInfo.fileUrl || fileInfo.file_name);
  var title = fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT);
  var qualities = parseVideoQualities(fileOutput);
  var adaptiveVideo = parseAdaptiveUrls(fileOutput);
  var mediaFeatures = parseMediaFeatures(fileInfo);
  // parse poster - get the first item in data
  var imageData = _lodash2.default.head(fileOutput.image);
  var posterImageRef = {
    type: 'Image',
    width: imageData.width,
    height: imageData.height,
    uri: url2uri(imageData.url),
    description: info.path ? info.path : undefined
  };

  var parsed = {
    type: 'WixVideo',
    title: title,
    videoId: videoId,
    duration: +(fileInput.duration / 1000).toFixed(2),
    posterImageRef: posterImageRef,
    generatedPosters: parseVideoPosters(fileOutput),
    qualities: qualities,
    adaptiveVideo: adaptiveVideo,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' },
    hasAudio: getObjectValueByKey(_lodash2.default.head(fileOutput.video), 'audio_bitrate') !== -1,
    fps: _lodash2.default.get(_lodash2.default.head(fileOutput.video), 'fps', '').toString()
  };

  if (mediaFeatures) {
    parsed.mediaFeatures = mediaFeatures;
  }

  return parsed;
}

function getVideoBackgroundObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _lodash2.default.assign(mediaObject, BG_VIDEO_DEFAULTS);
}

function getMediaPlayerVideoObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _lodash2.default.assign(mediaObject, MEDIA_PLAYER_DEFAULTS);
}

function getVideoPosterObject(videoId, uri, width, height) {
  return {
    type: 'WixVideo',
    videoId: videoId,
    posterImageRef: {
      type: 'Image',
      uri: uri,
      width: width,
      height: height
    }
  };
}

/**
 *
 * @param fileInfo
 * @param info - media manager, folder information
 * @returns {{uri: *, title: *, width: *, height: *}}
 */
function getImageBackgroundObject(fileInfo, info) {
  return {
    type: 'Image',
    uri: fileInfo.fileName,
    title: fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT),
    description: info.path,
    width: fileInfo.width,
    height: fileInfo.height,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' }
  };
}
//# sourceMappingURL=backgroundUtils.js.map